"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(_ref) {
  var alt = _ref.alt,
      file = _ref.file,
      height = _ref.height,
      lazy = _ref.lazy,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      width = _ref.width;
  return /*#__PURE__*/_react.default.createElement("img", {
    src: file,
    alt: alt !== null && alt !== void 0 ? alt : title,
    loading: lazy ? "lazy" : "eager",
    style: {
      display: "block",
      height: "100%",
      objectFit: "cover",
      width: "100%"
    },
    height: height,
    width: width
  });
};

Image.propTypes = {
  alt: _propTypes.default.string,
  file: _propTypes.default.string.isRequired,
  height: _propTypes.default.number,
  title: _propTypes.default.string,
  width: _propTypes.default.number
};
var _default = Image;
exports.default = _default;